import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { externalLink } from '../../../../configs/externalLink'
import { ExternalLink } from '../../../common/ExternalLink'
import { Element } from '../../../common/html/element'
import classes from './index.module.scss'

const DECLARES = ['DECLARE_1', 'DECLARE_2', 'DECLARE_3']

export const Declaration = () => {
  const locale = useSelector((state) => state.i18n.locale)

  return (
    <Element className={classes.container}>
      {DECLARES.map((item, index) => (
        <Element
          key={item}
          className={classes.declare}
          style={{
            borderColor: '#0553A5',
            backgroundColor: '#EDF5FE',
            color: '#3A414B',
          }}
        >
          {index === 1 ? (
            <>
              <Translate value={`filingStatus.DECLARE_2_1`} />
              <ExternalLink href={externalLink.PROVINCES[locale]}>
                <Translate value={`filingStatus.DECLARE_2_2`} />
              </ExternalLink>
              <Translate value={`filingStatus.DECLARE_2_3`} />
            </>
          ) : (
            <Translate value={`filingStatus.${item}`} />
          )}
        </Element>
      ))}
    </Element>
  )
}
